module.exports = __webpack_public_path__ + "img/second-footer-icon.9c680e91.svg";